import { Sprite, Object3D } from "three";

export function setVisibleSpriteTextInObj({ targetObject, visible }) {
    if (!(targetObject instanceof Object3D)) {
        return console.warn("[setVisibleSpriteTextInObj]: некорректный объект:", targetObject);
    }

    if (typeof visible !== "boolean") {
        return console.warn("[setVisibleSpriteTextInObj]: некорректное значение visible:", visible);
    }

    targetObject.children.forEach((child) => {
        if (child instanceof Sprite) {
            child.visible = visible;
        }
    });
}
